export const SWEEPSTAKES_NR_ACTIONS = {
  CTA_CLICK: 'sweepstakes_cta_click',
};

export const SWEEPSTAKES_NR_CTA = {
  ENTRY_CARD_UNAUTH_SIGN_IN: 'entry_card_unauth_sign_in',
  ENTRY_CARD_PURCHASER_SIGN_IN: 'entry_card_purchaser_sign_in',
  ENTRY_CARD_GET_STARTED: 'entry_card_get_started',
  ENTRY_CARD_EARN_MORE_ENTRIES: 'entry_card_earn_more_entries',
  ENTRY_CARD_REVIEW_ENTRIES: 'entry_card_review_entries',
  DRAWER_OPT_IN: 'drawer_opt_in',
  DRAWER_FORCE_LOGOUT: 'drawer_force_logout',
  DETAILS_DRAWER_ENTER_NOW: 'details_drawer_enter_now',
  DETAILS_DRAWER_MEET_THE_APP_WATCH_NOW: 'details_drawer_meet_the_app_watch_now',
  DETAILS_DRAWER_GET_FAST_DELIVERY_SHOP_NOW: 'details_drawer_get_fast_delivery_shop_now',
  DETAILS_DRAWER_TRY_STORE_MODE_GET_STARTED: 'details_drawer_try_store_mode_get_started',
  STEP_DRAWER_STANDARD_CTA: 'step_drawer_standard_cta',
  STEP_DRAWER_SUBMIT_ENTRY: 'step_drawer_submit_entry',
};

export const newrelic = {
  addPageAction: (name, value) => {
    if (
      typeof window !== 'undefined'
      && typeof window.newrelic?.addPageAction === 'function'
    ) {
      window.newrelic.addPageAction(name, value);
    }
  },
};

export const trackSweepstakesCtaClick = (ctaName, attributes = {}) => {
  if (!ctaName) return;

  newrelic.addPageAction(SWEEPSTAKES_NR_ACTIONS.CTA_CLICK, {
    ctaName,
    ...attributes,
  });
};
